export default __webpack_public_path__ + "static/media/btn_close_hover.2431ded3.svg";